


















import Vue from 'vue';
import Topic from '../../../../settings/models/Topic';
import settingsClient from '../../../../settings/apis';
import commonVuex from '../../../../common/vuex/common';
import customerVuex from '../../../../customer/vuex/common';
import scheduleRuleVuex from '../../../vuex/common';

export default Vue.extend({
  mixins: [commonVuex, customerVuex, scheduleRuleVuex],
  data() {
    return {
      selectedId: 0,
    };
  },
  methods: {
    loadTopics() {
      settingsClient.getTopics().success((r: any) => {
        this.$store.commit('SET_TOPICS', r.topics);
      });
    },
    updateTopicId(id: number) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'topics',
        value: [id],
      });
    },
  },
  mounted() {
    if (this.customerFilter.topics) {
      this.selectedId = this.customerFilter.topics[0];
    }
    if (this.scheduleRule &&
        this.scheduleRule.ruleContext &&
        this.scheduleRule.ruleContext.Periodic.query.topics) {
      this.selectedId = this.scheduleRule.ruleContext.Periodic.query.topics[0];
    }
    this.loadTopics();
  },
});
